"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

export function Providers({ children }: { children: React.ReactNode }) {
  // refetchOnWindowFocus off: builder sections seed a local form from the agent
  // query, so a focus-triggered refetch would reset in-progress edits (e.g. a
  // half-made dropdown selection) back to the saved value.
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: { queries: { refetchOnWindowFocus: false, staleTime: 10_000 } },
      })
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
